<template>
  <div class="nodis-wrap">
    <div class="nodis-form">
      <div class="nodis-line">
        <h3 class="form-title">我不希望展示在官网</h3>
      </div>
      <div class="nodis-line">
        <div class="nodis-input-wrap">
          <input
            type="text"
            class="nodis-input"
            v-model="formData.memberName"
            placeholder="吉客号"
            @change="validateMemberName(formData.memberName)"
          />
          <div
            class="nodis-error-tip"
            v-if="validateData.memberNameError"
          >{{validateData.memberNameErrorTip}}</div>
        </div>
      </div>
      <div class="nodis-line">
        <div class="nodis-input-wrap">
          <input
            type="text"
            class="nodis-input"
            v-model="formData.contactMan"
            placeholder="联系人"
            @change="validateContactMan(formData.contactMan)"
          />
          <div
            class="nodis-error-tip"
            v-if="validateData.contactManError"
          >{{validateData.contactManErrorTip}}</div>
        </div>
      </div>
      <div class="nodis-line">
        <div class="nodis-input-wrap">
          <input
            type="tel"
            class="nodis-input"
            v-model="formData.contactNumber"
            placeholder="电话号码"
            @keyup="onlyNumber('contactNumber', 20)"
            @change="validateContactNumber(formData.contactNumber)"
          />
          <div
            class="nodis-error-tip"
            v-if="validateData.contactNumberError"
          >{{validateData.contactNumberErrorTip}}</div>
        </div>
      </div>
      <div class="nodis-line">
        <div class="nodis-input-wrap">
          <input
            type="tel"
            class="nodis-input"
            v-model="formData.contactQq"
            placeholder="QQ"
            @keyup="onlyNumber('contactQq', 12)"
            @change="validateContactQq(formData.contactQq)"
          />
          <div
            class="nodis-error-tip"
            v-if="validateData.contactQqError"
          >{{validateData.contactQqErrorTip}}</div>
        </div>
      </div>
      <div class="nodis-line">
        <div class="nodis-input-wrap">
          <input
            type="text"
            class="nodis-input form-Authcode"
            v-model="formData.verificationCode"
            placeholder="验证码"
            @change="validateVerificationCode(formData.verificationCode)"
            @keyup="onlyNumber('verificationCode', 6)"
          />
          <div class="authcode-wrap" @click="_getAuthCode">
            <img :src="authcodeUrl" alt="验证码" />
          </div>
          <div
            class="nodis-error-tip"
            v-if="validateData.verificationCodeError"
          >{{validateData.verificationCodeErrorTip}}</div>
        </div>
      </div>
      <div class="nodis-line">
        <div class="nodis-input-wrap nodis-btns-wrap">
          <div class="btn-save" @click="submitApply">确定</div>
          <div class="btn-close" @click="$emit('close')">关闭</div>
        </div>
      </div>
    </div>
    <div class="nodis-close" @click="$emit('close')"></div>
    <div class="nodis-success-wrap" v-if="isSubmitSuccess">
      <div class="nodis-success-popup">
        <img src="../assets/mask/success.png" alt="成功" class="nodis-success-img" />
        <p class="nodis-success-p1">申请提交成功！</p>
        <p class="nodis-success-p2">我们会尽快处理,谢谢！</p>
        <div class="nodis-success-btn" @click="$emit('close')">关闭</div>
      </div>
    </div>
  </div>
</template>

<script >
import { getVerificationCode, submitRefuseShow } from "@/api";
import { Message } from "element-ui";
export default {
  name: "complaint",
  components: {},
  data() {
    return {
      formData: {
        memberName: "",
        contactMan: "",
        contactNumber: "",
        contactQq: "",
        verificationCode: ""
      },
      validateData: {
        memberNameError: false,
        contactManError: false,
        contactNumberError: false,
        contactQqError: false,
        titleError: false,
        contentError: false,
        verificationCodeError: false,
        memberNameErrorTip: "不能为空",
        contactManErrorTip: "不能为空",
        contactNumberErrorTip: "不能为空",
        contactQqErrorTip: "不能为空",
        titleErrorTip: "不能为空",
        contentErrorTip: "不能为空",
        verificationCodeErrorTip: "不能为空"
      },
      identification: "",
      authcodeUrl: "",
      submitting: false,
      isSubmitSuccess: false
    };
  },
  methods: {
    submitApply() {
      // 提交表单
      if (this.submitting) return; // 防止连续点击
      let keys = Object.keys(this.formData),
        flag = true;
      keys.forEach(key => {
        // 表单验证
        let methodName = "validate" + key.replace(key[0], key[0].toUpperCase());
        this[methodName](this.formData[key]);
        if (this.validateData[key + "Error"]) {
          flag = false;
        }
      });
      if (!flag) return;
      let params = Object.assign({}, this.formData);
      params.identification = this.identification; // 加上身份标识
      this.submitting = true;
      submitRefuseShow(params)
        .then(res => {
          // 调用接口
          if (res.code === 200) {
            this.isSubmitSuccess = true;
          } else if (res.subCode === "0201121109") {
            // 验证码错误
            this.validateData.verificationCodeError = true;
            this.validateData.verificationCodeErrorTip = "验证码错误";
          } else if (res.subCode === "0201121156") {
            // 吉客号未展示
            this.validateData.memberNameError = true;
            this.validateData.memberNameErrorTip = "此吉客号未展示";
          } else if (res.subCode === "0201121155") {
            // 吉客号不存在
            this.validateData.memberNameError = true;
            this.validateData.memberNameErrorTip = "吉客号不存在";
          }
          this._getAuthCode();
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    validateMemberName(val) {
      if (!val) {
        this.validateData.memberNameError = true;
        this.validateData.memberNameErrorTip = "请输入吉客号！";
        return;
      }
      if (val.length > 10) {
        this.validateData.memberNameError = true;
        this.validateData.memberNameErrorTip = "格式错误！";
        return;
      }
      this.validateData.memberNameError = false;
    },
    validateContactMan(val) {
      if (!val) {
        this.validateData.contactManError = true;
        this.validateData.contactManErrorTip = "请输入联系人！";
        return;
      }
      if (val.length > 20) {
        this.validateData.contactManError = true;
        this.validateData.contactManErrorTip = "长度不能超过20！";
        return;
      }
      if (!/^[a-zA-Z\u4e00-\u9fa5]+$/.test(val)) {
        this.validateData.contactManError = true;
        this.validateData.contactManErrorTip = "只能输入中英文！";
        return;
      }
      this.validateData.contactManError = false;
    },
    validateContactNumber(val) {
      if (!val) {
        this.validateData.contactNumberError = true;
        this.validateData.contactNumberErrorTip = "请输入联系电话！";
        return;
      }
      let phoneReg = /^(1[3-9]{1})\d{9}$/,
        telReg = /^(0\d{2,3}-?\s?)?\d{7,8}$/;
      if (!phoneReg.test(val) && !telReg.test(val)) {
        this.validateData.contactNumberError = true;
        this.validateData.contactNumberErrorTip = "格式错误！";
        return;
      }
      this.validateData.contactNumberError = false;
    },
    validateContactQq(val) {
      if (!val) {
        this.validateData.contactQqError = true;
        this.validateData.contactQqErrorTip = "请输入QQ号";
        return;
      }
      if (!/^[1-9][0-9]{3,11}$/.test(val)) {
        this.validateData.contactQqError = true;
        this.validateData.contactQqErrorTip = "格式错误！";
        return;
      }
      this.validateData.contactQqError = false;
    },
    validateVerificationCode(val) {
      if (!val) {
        this.validateData.verificationCodeError = true;
        this.validateData.verificationCodeErrorTip = "请输入验证码！";
        return;
      }
      this.validateData.verificationCodeError = false;
    },
    onlyNumber(key, len) {
      let val = this.formData[key];
      if (val.length > len) {
        this.formData[key] = val.substring(0, len);
      }
      if (/[^\d]/g.test(val)) {
        this.formData[key] = val.replace(/[^\d]/g, "");
      }
    },
    _getAuthCode() {
      this.authcodeUrl =
        "/cms-pdrs/open/website/getVerificationCode?identification=" +
        this.identification +
        "&timestamp=" +
        new Date().getTime();
    }
  },
  created() {
    this.identification =
      "" + new Date().getTime() + Math.floor(Math.random() * 1000);
    this.authcodeUrl =
      "/cms-pdrs/open/website/getVerificationCode?identification=" +
      this.identification;
  }
};
</script>

<style lang="less" scope>
.nodis-wrap {
  position: relative;
  margin: auto;
  width: 630px;
  height: 480px;
  background-color: rgba(251, 251, 251);
  font-family: Source Han Sans CN;
}
.nodis-form {
  width: 564px;
  padding-top: 14px;
  height: auto;
  margin: auto;
}
.form-title {
  height: 30px;
  margin: 30px auto;
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
}
.nodis-input-wrap {
  position: relative;
  height: 36px;
  margin-bottom: 10px;
}
.nodis-input {
  box-sizing: border-box;
  width: 374px;
  height: 36px;
  padding-left: 15px;
  border: 1px solid #ececec;
  border-radius: 4px;
  outline: none;
  color: #666;
}
.nodis-input:focus {
  border-color: #409eff;
  z-index: 1;
}
.form-Authcode {
  vertical-align: top;
  width: 268px;
}
.authcode-wrap {
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  width: 96px;
  height: 36px;
  margin-left: 6px;
  border: 1px solid #ececec;
  background-color: #fff;
  cursor: pointer;
}
.nodis-btns-wrap {
  display: flex;
  justify-content: space-around;
  width: 374px;
  margin: 65px auto auto auto;
}
.btn-save,
.btn-close {
  display: inline-block;
  width: 160px;
  height: 36px;
  background-color: #5485e8;
  font-size: 18px;
  text-align: center;
  line-height: 36px;
  color: #fff;
  cursor: pointer;
}
.btn-close {
  background-color: #fff;
  border: 1px solid #ececec;
  color: #999999;
}
.nodis-error-tip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 480px;
  width: 120px;
  text-align: left;
  color: #eb5555;
}

  .nodis-close {
    position: absolute;
    right: 14px;
    top: 11px;
    width: 30px;
    height: 24px;
  }

  .nodis-close::before,
  .nodis-close::after {
    position: absolute;
    content: " ";
    background-color: #999;
    left: 20px;
    width: 2px;
    height: 25px;
  }

  .nodis-close::before {
    transform: rotate(45deg);
  }

  .nodis-close::after {
    transform: rotate(-45deg);
  }

  .nodis-close:hover:before,
  .nodis-close:hover:after{
    background-color: #5485E8;
  }
.nodis-success-wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.nodis-success-popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 440px;
  height: 240px;
  background-color: #fff;
  text-align: center;
  box-shadow: 1px 1px 6px #999;
}
.nodis-success-img {
  width: 48px;
  height: 48px;
  margin: 30px auto 20px auto;
}
.nodis-success-p1 {
  margin: 0 auto 12px auto;
  font-size: 20px;
  color: #333333;
}
.nodis-success-p2 {
  margin-bottom: 16px;
  font-size: 16px;
  color: #999999;
}
.nodis-success-btn {
  width: 180px;
  height: 36px;
  margin: auto;
  border: 1px solid #e1dede;
  line-height: 36px;
  color: #999;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/no-display.vue